<template>
  <v-card class="my-6 pa-6">
    Featured Creations
  </v-card>
</template>

<script>
export default {
  name: 'FeaturedCreations',
}
</script>

<style lang="scss" scoped>
</style>